export default "__VITE_ASSET__dzcRRh4m__"